<div class="modal-body">
  <div class="row">
    <h2 class="modal-title">{{ 'brapi-sync.germplasm.heading' | translate }}</h2>
  </div>
  <div class="row pt-2">
    <div class="col-10">
      <app-study-selector (onSelect)="onStudySelect()"></app-study-selector>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          @if (context.sourceStudy && context.sourceStudy.studyDbId) {
            <app-collapsible [heading]="'brapi-sync.germplasm.connection-info' | translate">
              <div class="card">
                <div class="card-body">
                  <h5><span
                  class="badge badge-pill text-bg-success text-white">{{ context.sourceStudy.studyName }}</span>
                </h5>
              </div>
            </div>
          </app-collapsible>
          <app-collapsible [heading]="'brapi-sync.germplasm.options' | translate">
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input" name="importAncestorsCheckbox"
                id="importAncestorsCheckbox" [(ngModel)]="isImportAncestors" (change)="load()">
              <label class="custom-control-label"
              for="importAncestorsCheckbox">{{ 'brapi-sync.germplasm.import-ancestors' | translate }}</label>
            </div>
            <div class="card mt-2">
              <div class="card-body">
                <form>
                  <div class="form-group row">
                    <label for="numberOfGenerations"
                    class="col-sm-2 col-form-label">{{ 'brapi-sync.germplasm.number-of-generations' | translate }}</label>
                    <div class="col-sm-1 pt-1">
                      <input type="number" class="form-control" name="numberOfGenerationsText"
                        id="numberOfGenerationsText" [(ngModel)]="numberOfGenerations"
                        [disabled]="!isImportAncestors" min="1" max="15">
                    </div>
                    <div class="col-sm-1 pt-1">
                      <button type="button" class="btn btn-primary" (click)="load()"
                        [disabled]="!isImportAncestors">{{ 'apply' | translate }}
                      </button>
                    </div>
                  </div>
                  <div class="form-check form-switch pt-2">
                    <input type="checkbox" class="form-check-input"
                      name="connectWithTargetAncestorsCheckbox"
                      id="connectWithTargetAncestorsCheckbox"
                      [(ngModel)]="isAttemptToConnectTargetAncestors"
                      [disabled]="!isImportAncestors" (change)="load()">
                    <label class="custom-control-label"
                    for="connectWithTargetAncestorsCheckbox">{{ 'brapi-sync.germplasm.attempt-to-connect' | translate }}</label>
                  </div>
                </form>
              </div>
            </div>
          </app-collapsible>
          <app-collapsible [heading]="'brapi-sync.germplasm.germplasm-mapping' | translate">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="selectAll"
                (click)="onSelectAllPages()" [checked]="isSelectAllPages">
              <label class="form-check-label" for="selectAll">
                {{ 'brapi-sync.germplasm.select-all' | translate }}
              </label>
            </div>
            <div class="table-responsive pt-2">
              <div class="custom-scroll-style adjustable-height">
                <table class="table table-striped table-bordered table-curved">
                  <thead class="sticky-header">
                    <tr>
                      @if (germplasm.length && !isSelectAllPages) {
                        <th>
                          <input type="checkbox" class="form-check-input"
                            [ngbTooltip]="'brapi-sync.germplasm.tooltip.select-current-page' | translate"
                            [openDelay]="800" [checked]="isPageSelected()"
                            (click)="onSelectPage()"
                            [title]="'brapi-sync.germplasm.tooltip.select-current-page' | translate"/>
                        </th>
                      }
                      <th>{{ 'brapi-sync.germplasm.table.id' | translate }}</th>
                      <th>{{ 'brapi-sync.germplasm.table.germplasm-name' | translate }}</th>
                      <th>{{ 'brapi-sync.germplasm.table.synonyms' | translate }}</th>
                      <th>{{ 'brapi-sync.germplasm.table.origin' | translate }}</th>
                      <th>{{ 'brapi-sync.germplasm.table.documentation-url' | translate }}</th>
                      <th>{{ 'brapi-sync.germplasm.table.acquisition-date' | translate }}</th>
                      @if (this.isImportAncestors) {
                        <th>{{ 'brapi-sync.germplasm.table.source-pedigree' | translate }}</th>
                      }
                      @if (this.isImportAncestors) {
                        <th>{{ 'brapi-sync.germplasm.table.preview-target-pedigree' | translate }}</th>
                      }
                      <th>{{ 'brapi-sync.germplasm.table.breeding-method-name' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (germplasm.length && isNumberOfGenerationsValid) {
                      @for (row of germplasm; track row) {
                        <tr>
                          @if (!isSelectAllPages) {
                            <td>
                              @if (isSelectable(row, invalidPedigreeNodes)) {
                                <input class="form-check-input"
                                  type="checkbox" [checked]="isSelected(row)"
                                  (click)="toggleSelect(row)">
                              }
                            </td>
                          }
                          @if (isLoading) {
                            <td>{{ row.germplasmDbId }}</td>
                          } @else {
                            <td [ngClass]="isGermplasmExistsInDestination(row, germplasmInDestinationByPUIs, germplasmInDestinationByReferenceIds) ? 'table-cell-yellow' : 'table-cell-green'">
                              <span [openDelay]="800"
                                [ngbTooltip]="isGermplasmExistsInDestination(row, germplasmInDestinationByPUIs, germplasmInDestinationByReferenceIds) ? ('brapi-sync.germplasm.tooltip.already-exists' | translate) : ('brapi-sync.germplasm.tooltip.does-not-exist' | translate)">
                                {{ row.germplasmDbId }}
                              </span>
                            </td>
                          }
                          <td><a (click)="showGermplasmSourceModal(row)"
                          href="javascript: void(0)">{{ row.germplasmName }}</a></td>
                          <td>{{ getSynonyms(row.synonyms) }}</td>
                          <td>{{ row.countryOfOrigin }}</td>
                          <td>{{ row.documentationURL }}</td>
                          <td>{{ row.acquisitionDate }}</td>
                          @if (this.isImportAncestors) {
                            <td><a
                              (click)="showPedigreeGraph(row, false)"
                            href="javascript: void(0)">{{ row.germplasmName }}</a></td>
                          }
                          @if (this.isImportAncestors) {
                            <td>
                              @if (this.isAttemptToConnectTargetAncestors && !hasInvalidPedigreeNodes(row.germplasmDbId, invalidPedigreeNodes)) {
                                <i
                                class="fa fa-check text-success ps-1" title=""></i>
                              }
                              @if (this.isAttemptToConnectTargetAncestors && hasInvalidPedigreeNodes(row.germplasmDbId, invalidPedigreeNodes)) {
                                <i
                                class="fa fa-times text-danger ps-1" title=""></i>
                              }
                              &nbsp;&nbsp;
                              <a (click)="showPedigreeGraph(row, true)"
                              href="javascript: void(0)">{{ pedigreeUtilService.getMatchingGermplasmInDestination(row, germplasmInDestinationByPUIs, germplasmInDestinationByReferenceIds)?.germplasmName || row.germplasmName }}</a>
                            </td>
                          }
                          <td>
                            @if (!this.breedingMethodsSourceById[row.breedingMethodDbId]) {
                            } @else if (!this.getBreedingMethodIdInDestination(row)) {
                              <i class="fa fa-times text-danger" [openDelay]="800"
                              [ngbTooltip]="'brapi-sync.germplasm.tooltip.doesnt-exists-in-target' | translate"></i> {{ this.breedingMethodsSourceById[row.breedingMethodDbId]?.breedingMethodName }}
                            } @else if (this.hasDifferentBreedingMethods(row)) {
                              <i class="fa fa-times text-danger" [openDelay]="800"
                              [ngbTooltip]="'brapi-sync.germplasm.tooltip.different-breeding-method' | translate"></i> {{ this.breedingMethodsSourceById[row.breedingMethodDbId]?.breedingMethodName }}
                            } @else {
                              <i class="fa fa-check text-success" [openDelay]="800"
                              [ngbTooltip]="'brapi-sync.germplasm.tooltip.exists-in-target' | translate"></i> {{ this.breedingMethodsSourceById[row.breedingMethodDbId]?.breedingMethodName }}
                            }
                          </td>
                        </tr>
                      }
                    } @else {
                      <tr>
                        <td colspan="10">{{ 'no.data' | translate }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

            </div>
            <div class="row">
              <div class="col">
                <div class="pagination-container">
                  <div class="pagination-box pagination-box-left">
                    <div>
                      <jhi-item-count-custom [page]="page" [total]="totalCount"
                      [itemsPerPage]="pageSize"></jhi-item-count-custom>
                    </div>
                  </div>
                  <div class="pagination-box" data-test="germplasmSearchResultsTablePagination">
                    <ngb-pagination [collectionSize]="totalCount" [(page)]="page"
                      [pageSize]="pageSize" [disabled]="isLoading"
                      [maxSize]="5" [rotate]="true"
                    (pageChange)="load()"></ngb-pagination>
                  </div>
                  <div class="pagination-box pagination-box-right">
                    <div class="d-flex align-items-center">
                      <label for="itemsPerPage" class="control-label control-label-left"
                      jhiTranslate="global.items.per.page"></label>
                      <select [(ngModel)]="pageSize" class="form-select ms-2"
                        id="itemsPerPage" [disabled]="isLoading"
                        (change)="onPageSizeChanged()" style="width:95px">
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </app-collapsible>
        }
      </div>
    </div>
  </div>
</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="back()">{{ 'back' | translate }}
  </button>
  <button type="button" class="btn btn-primary ms-2" (click)="importSelectedGermplasm()"
    [disabled]="isSaving || !(size(selectedItems) || isSelectAllPages && germplasm.length)">
    @if (isSaving) {
      <span class="throbber throbber-btn"></span>
    }
    {{ 'brapi-sync.buttons.import' | translate }}
  </button>
</div>

<ng-template #downloadError>
    <div class="row">
        <div class="col">
            <span>{{'brapi-sync.germplasm.error.there-are-errors-during-import' | translate}} <a href="javascript:void(0)" (click)="downloadErrorsAndInfo()"> {{ 'brapi-sync.germplasm.error.download-details-here' | translate }}</a></span>
        </div>
    </div>
</ng-template>
